<template>
    <v-container class="pa-0 ma-0 mt-12 mb-6" fluid>
        <v-carousel cycle class="" height="65vh">
            <v-carousel-item v-for="item in items"
                             :src="item.picture" :key="item.title"
            >
                <v-row
                        align="center"
                        justify="center"
                        class="white--text"
                        style="height: 100%"
                >
                    <v-col class="" cols="12" md="8" offset-md="1">
                        <h1 class="display-4 font-weight-bold font-weight-thin mb-4"
                            style="text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;"
                        >{{item.title}}</h1></v-col>

                    <v-col cols="12" style="background-color:rgba(5,146,201,.6)">
                        <v-row>
                            <v-col cols="12" md="11" offset-md="1">
                                <h3 class="headline" :class="$vuetify.breakpoint.smAndUp?'pl-12':'pl-6'">
                                    {{item.subtitle}}</h3></v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-carousel-item>
        </v-carousel>
        <v-img src="../../public/img/health.webp" gradient="to top right, rgba(233,153,34,.9), rgba(233,153,34,.9)"
               height="calc( 35vh - 48px )">
            <v-row
                    align="center"
                    justify="center"
                    class="mb-0"

            >
                <v-col class="pa-0 ml-1 mr-1" cols="12" md="8">
                    <v-card class="transparent fill-height pa-0 elevation-0" dark>
                        <v-card-text style="height: 20vh" class=""
                                     :class="$vuetify.breakpoint.smAndDown?'subtitle-1 font-weight-bold':'display-1'">
                            <v-row justify="center">
                                <v-col align-content="center" class="pt-0" justify-content="center">Le jeu au service de
                                    la santé. La force de l’intelligence collective concentrée pendant 48h.
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="$vuetify.goTo('#description')" v-if="$vuetify.breakpoint.xsOnly"
                                   style="background-color: rgba(5, 146, 201, 1)" class="ma-auto col-sm-10">
                                <v-icon>mdi-arrow-down-bold-circle-outline</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn @click="$vuetify.goTo('#description ')" v-if="$vuetify.breakpoint.smAndUp">
                                <v-icon>mdi-arrow-down-drop-circle</v-icon>
                                En savoir plus
                            </v-btn>

                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-img>
        <description id="description"></description>
        <v-img src="../../public/img/health.webp" gradient="to top right, rgba(233,153,34,.9), rgba(233,153,34,.9)"
               height="90px">
            <v-row
                    class="fill-height ma-0 text-center white--text"
                    :class="$vuetify.breakpoint.smAndUp?'display-3':'display-1'"
                    align="center"
                    justify="center"
            >
                Les partenaires de l'événement
            </v-row>
        </v-img>
        <participant></participant>
        <v-img src="../../public/img/health.webp" gradient="to top right, rgba(233,153,34,.9), rgba(233,153,34,.9)"
               height="30px"></v-img>
        <information-dates id="manetteDate"></information-dates>
    </v-container>
</template>

<script>
    // @ is an alias to /src

    import InformationDates from "../components/InformationDates";
    import Description from "../components/Description";
    import Participant from "../components/Participant";

    export default {
        name: 'home',
        components: {Participant, Description, InformationDates},
        data() {
            return {
                colors: [
                    'primary',
                    'secondary',
                    'yellow darken-2',
                    'red',
                    'orange',
                ],
                items: [
                    {
                        picture: require("../../public/img/banner.png"),
                        title: "",
                        subtitle: "Le jeu au service de la santé !"
                    },
                    {
                        picture: require("../../public/img/game.jpg"),
                        title: "Le jeu",
                        subtitle: "Un moteur naturel pour le corps et l'esprit !"
                    },
                    {
                        picture: require("../../public/img/science.jpg"),
                        title: "La science",
                        subtitle: "Pour aller plus loin !"
                    },
                    {
                        picture: require("../../public/img/creativity.jpg"),
                        title: "Le collectif",
                        subtitle: "Pour mettre en avant la créativité !"
                    }
                ]
            }
        }
    }
</script>
<style scoped>
    .v-carousel__item {
        height: 100% !important;
    }
</style>